import React, { useEffect } from 'react';
import cn from 'classnames';
import Button from 'components/UI/Button';
import Summary from '../components/Summary';
import { useTrans } from 'utils/localisation';
import { observer, pricingCalculator as store } from 'store';
import * as styles from './ModalFooter.module.scss';

function ModalFooter({ id, businessNeed, steps, handleClose }) {
  const t = useTrans(['common', 'pricingCalculator']);
  const lastStep = steps?.length + 1;
  const { currentStep, isSubmitting, setStep, nextStep, prevStep, getPayload } = store;
  const last = currentStep === lastStep;
  const payload = getPayload();
  const currentStepLabel = steps?.[currentStep - 1]?.label;
  const currentStepSelectedData = payload[currentStepLabel];

  const handleNext = () => {
    if (!last && currentStep < lastStep) {
      nextStep();
    }
  };

  const goBack = () => {
    if (currentStep === 1) {
      handleClose();
    } else {
      prevStep();
    }
  };

  useEffect(() => {
    return () => {
      setStep(1);
    };
  }, []);

  return (
    <div className={cn(styles.modalFooter, styles.withSummary)}>
      <Summary businessNeed={businessNeed} items={payload} />
      <div className={styles.buttonsWrapper}>
        <Button onClick={goBack} size="sm" theme="secondary">
          {t('back')}
        </Button>
        {!last && (
          <Button onClick={handleNext} size="sm" disabled={!currentStepSelectedData}>
            {t('next')}
          </Button>
        )}
        {last && (
          <Button size="sm" type="submit" form={id} disabled={isSubmitting}>
            {t('send')}
          </Button>
        )}
      </div>
    </div>
  );
}

export default observer(ModalFooter);
